import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form';
import { formatMoney } from '@shopify/theme-currency';

import '../../styles/components/product-form.scss';

import { addToCartForm } from '../utils/cart';

class ProductFormElement extends HTMLElement {
  constructor() {
    super();

    this.productWrapper = this.closest("[data-product-wrapper]");
    this.skuContainer = this.productWrapper?.querySelector("[data-product-sku-container]");
    this.skuElement = this.productWrapper?.querySelector("[data-product-sku]");
    this.priceElementNodes = this.productWrapper?.querySelectorAll("[data-price]");
    this.priceElement = this.priceElementNodes && Array.from(this.priceElementNodes);
    this.comparePriceElementNodes = this.productWrapper?.querySelectorAll("[data-compare-at-price]");
    this.comparePriceElement = this.comparePriceElementNodes && Array.from(this.comparePriceElementNodes);
    this.priceWrapperElement = this.productWrapper?.querySelector(".price");

    this.imageSwiper = this.productWrapper?.querySelector("[data-product-image-swiper]");
    this.thumbsSwiper = this.productWrapper?.querySelector("[data-product-thumbs-swiper]");

    this.productHandle = this.getAttribute('product-handle');
    this.productFormElement = this.querySelector('form');
    this.submitButton = this.querySelector('button[data-submit-product]');
    this.submitOption = this.querySelector('[data-option-submit-product]');
    this.selectId = this.querySelector('[name="id"]');
    this.buttonTitle = this.querySelector('[data-button-title]');
    this.variantsEnddate = this.getEnddateJson();
    this.variantsWid1 = this.getWid1Json();
    this.variantsWid2 = this.getWid2Json();
    this.isExtention = this.submitButton.hasAttribute("data-is-extension");
    this.dateSelect = this.querySelector('[data-date-select]');
    this.isValidEmail = false;

    this.selectDefaults = Array.from(this.querySelectorAll("[data-select-option-selector]"));
    this.requiredInput = this.querySelector("input[name*='_PEBC_ID']");

    this.allSwatches = Array.from(this.querySelectorAll('[data-option-position]'));

    this.initializeForm();

    this.productFormElement.addEventListener('submit', this.submitProductForm.bind(this));

    if (this.submitOption) {
      this.submitOption.addEventListener('change', this.optionSubmit.bind(this));
    }

    this.productsRedirect = this.querySelector('[data-products-redirect]');
    if (this.productsRedirect) {
      this.productsRedirect.addEventListener('change', function() {
        window.location.href = this.value;
      });
    }

    if (this.isExtention) {
      this.extensionEmailCheck();
    }

    // check if there are any query parameters
    this.productIsProtected = this.querySelector('[data-product-protected]');
    if(this.productIsProtected) {
      this.productIsProtectedValue = this.querySelector('[data-product-protected]').dataset.productProtected;
      this.queryParams = new URLSearchParams(window.location.search);

      if(this.productIsProtectedValue == "true") {
        this.requiredParams = this.querySelector('[data-required-params-metafields]').dataset.requiredParamsMetafields;
        this.currentTime = this.querySelector('[data-current-time]');
        this.atcButton = this.querySelector('[data-protected-product-available]')
        this.protectedErrorMessage = this.querySelector('[data-protected-error-message]');
        if(this.queryParams.size == 0) {
          this.atcButton.style = "display: none; pointer-events: none";
          this.protectedErrorMessage.classList.remove('hide');
        }
  
        if(this.queryParams.size > 0 && this.requiredParams && this.currentTime) {
          
          let missingParameters = false;
          this.queryParamsKeysArray = [];
          for (const key of this.queryParams.keys()) {
            this.queryParamsKeysArray.push(key);
          }
          this.requiredParamsKeysArray = this.requiredParams.split(',');
          this.requiredParamsKeysArray.forEach((key) => {
            if(!this.queryParamsKeysArray.includes(key)) {
              this.atcButton.style = "display: none; pointer-events: none";
              this.protectedErrorMessage.classList.remove('hide');
              missingParameters = true;
            }
          })
            
          this.matchingParameters = []; // parameters that match with the required ones
          this.requiredParamsValue = this.querySelector('[data-required-params-metafields]').dataset.requiredParamsMetafields;
          this.requiredParamsArray = this.requiredParamsValue.split(',');
          this.requiredParamsArray.sort();
  
          if(!missingParameters) {
            this.currentEpochTime = Math.floor(Date.now() / 1000);
            this.currentTime = this.querySelector('[data-current-time]');
            this.currentTime.value = this.currentEpochTime;

            // split the url to get the part after the 3rd slash
            // https://pharmachieve-canada.myshopify.com/products/product-handle?e=email&r=refemail
            // we want the slash right before products

            const url = new URL(window.location.href);
            const params = url.searchParams;
            const urlFirstPart = url.href.split('?')[0];

            let delimiter = '/';
            let start = 3;

            params.delete('hmac');
            let paramsWithoutHmac = params.toString();
            let tokens = urlFirstPart.split(delimiter).slice(start); // getting the url from the 3rd slash
            
            let hmacString = this.queryParams.get('hmac');
            let timestamp = this.queryParams.get('t');

            let urlSplit = `${tokens.join(delimiter)}`;
            let stringToEncode = `/${decodeURIComponent(urlSplit)}?${paramsWithoutHmac}`;
            // this would give something like /products/product-handle?e=test%40test.com&r=test1%40test.com&t=123456789
            // or the same but with page instead /pages/page-handle?e=test%40test.com&r=test1%40test.com&t=123456789

            this.querySelector('[data-string-to-encode]').value = stringToEncode;
            this.querySelector('[data-hmac-string]').value = hmacString;
            this.querySelector('[data-timestamp]').value = timestamp;
          }
        }   
      }
    }

  }

  async initializeForm() {
    this.product = this.getProductJson();

    this.productForm = new ProductForm(this.productFormElement, this.product, {
      onOptionChange: this.optionsChange.bind(this),
    });

    this.submitButton.disabled = this.defaultSelected();
    if (this.submitButton.dataset.productAvailable == "false") {
      this.submitButton.disabled = true;
    }

    this.selectDefaults.forEach(select => {
      select.addEventListener('change', () => {
        if (this.submitButton.dataset.productAvailable != "false") {
          this.submitButton.disabled = this.defaultSelected();
        }
      });
    });

    setInterval(() => {
      if (this.submitButton.dataset.productAvailable !== "false") {
        this.submitButton.disabled = this.defaultSelected();
      }
    }, 1000);
  }

  getProductJson() {
    return JSON.parse(this.querySelector('[data-product]').innerHTML);
  }

  getEnddateJson() {
    return JSON.parse(this.querySelector('[data-variants-enddate]').innerHTML);
  }

  getWid1Json() {
    return JSON.parse(this.querySelector('[data-variants-wid1]').innerHTML);
  }

  getWid2Json() {
    return JSON.parse(this.querySelector('[data-variants-wid2]').innerHTML);
  }

  async submitProductForm(event) {
    event.preventDefault();
    if (this.submitButton) {
      this.submitButton.classList.add('loading');
    }

    await addToCartForm(this.productFormElement);

    if (this.submitButton) {
      this.submitButton.classList.remove('loading');
    }
  }

  optionsChange(event) {
    const variant = event.dataset.variant;

    if (this.dateSelect) {
      this.checkDates();
    }

    this.updateBrowserHistory(variant);
    this.updateMainSelect(variant);
    this.updateProductPrice(variant);
    this.updateOutOfStockOptions(variant);
    this.updateSku(variant);
    this.updateEnddate(variant);
    this.updateWid1(variant);
    this.updateWid2(variant);
    this.updateSelectedOptions(variant);
    if (!this.isExtention && !this.isValidEmail) {
      this.updateProductButton(variant);
    }
    this.updateSlideImages(variant);
  }

  checkDates() {
    let options = [];
    let datePosition = undefined;

    this.allSwatches.forEach((swatch, i) => {
      if (swatch == this.dateSelect) {
        datePosition = i;
      }

      if (swatch.value) {
          options.push(swatch.value);
      }
    });

    if (options.length == 2) {
      options.push(null);
    }

    this.dateSelect.querySelectorAll("option").forEach(option => {
      let option1 = undefined;
      let option2 = undefined;
      let option3 = undefined;

      if (datePosition == 0) {
        option1 = option.value;
      } else {
        option1 = options[0]
      }

      if (datePosition == 1) {
        option2 = option.value;
      } else {
        option2 = options[1]
      }

      if (datePosition == 2) {
        option3 = option.value;
      } else {
        option3 = options[2]
      }

      var variantExists = this.product.variants.find(
        variantCompare =>
          variantCompare.option1 == option1 &&
          variantCompare.option2 == option2 &&
          variantCompare.option3 == option3 &&
          variantCompare.available
      );

      if (variantExists) {
        option.disabled = false;
      } else {
        option.disabled = true;
      }
    });

  }

  optionSubmit(event) {
    const elm = event.currentTarget;

    if (elm.hasAttribute('data-option-submit-product')) {
      this.submitProductForm();
    }
  }

  updateBrowserHistory(variant) {
    if (!variant) {
      return;
    }

    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({path: url}, '', url);
  }

  updateMainSelect(variant) {
    if(variant) {
      this.selectId.value = variant.id;
      this.selectId.dispatchEvent(new Event('change'));
    }
  }

  updateProductPrice(variant) {
    if (!this.priceWrapperElement) {
      return;
    }

    this.priceWrapperElement.classList.toggle('hide', !variant);

    if (variant) {
      this.priceElement?.forEach((price) => {
        if(!price.closest('[data-price-container]')?.classList.contains('button_price')){
          price.innerHTML = formatMoney(variant.price, theme.moneyFormat).replace('.00', '')
        }
      });

      this.comparePriceElement?.forEach((compareAtPrice) => {
        if(!compareAtPrice.closest('[data-price-container]')?.classList.contains('button_price')){
          compareAtPrice.innerHTML = formatMoney(compareAtPrice.price, theme.moneyFormat).replace('.00', '')
        }
      });

      if (variant.compare_at_price > variant.price) {
        this.priceWrapperElement.classList.add('price--on-sale');
      } else {
        this.priceWrapperElement.classList.remove('price--on-sale');
      }

      if (variant.available) {
        this.priceWrapperElement.classList.remove('price--sold-out');
      } else {
        this.priceWrapperElement.classList.add('price--sold-out');
      }
    }
  }

  updateSku(variant) {
    if (variant && this.skuElement && variant.sku) {
      this.skuElement.innerHTML = variant.sku;
    }

    if (this.skuContainer) {
      this.skuContainer.classList.toggle('hide', !variant || !variant.sku);
    }
  }

  updateEnddate(variant) {
    if (variant) {
      const productInput = document.querySelector('[data-product-enddate]');
      productInput.value = this.variantsEnddate[variant.id];
    }
  }

  updateWid1(variant) {
    if (variant) {
      const productInput = document.querySelector('[data-product-wid1]');
      productInput.value = this.variantsWid1[variant.id];
    }
  }

  updateWid2(variant) {
    if (variant) {
      const productInput = document.querySelector('[data-product-wid2]');
      productInput.value = this.variantsWid2[variant.id];
    }
  }

  updateSelectedOptions() {
    this.allSwatches.filter(swatch => swatch.checked).forEach(swatch => {
      const optionValue = swatch.value;

      const selectedOptionElement = swatch.closest('[data-option-container]').querySelector('[data-selected-option]');
      if(selectedOptionElement) {
        selectedOptionElement.innerHTML = optionValue;
      }
    });
  }

  defaultSelected() {
    let selectValue = false;

    this.selectDefaults?.forEach(select => {
      const selectedOption = select.options[select.selectedIndex];
      // Check if there are any enabled options available
      const hasEnabledOptions = Array.from(select.options).some(option => !option.disabled);

      // Only disable if selected option is disabled AND there are enabled options available
      if (selectedOption && selectedOption.disabled && hasEnabledOptions) {
        selectValue = true;
      }
    });

    if (this.requiredInput) {
      const value = this.requiredInput.value.trim();
      if (!value || value.length !== 6 || !/^\d{6}$/.test(value)) {
        selectValue = true;
      }
    }

    return selectValue;
  }

  updateProductButton(variant) {
    this.submitButton.innerHTML = "";

    if (!variant) {
      this.submitButton.disabled = true;
      this.submitButton.innerHTML = theme.strings.product.unavailable;
    } else if (variant.available) {
      this.submitButton.disabled = this.defaultSelected();
      if (this.buttonTitle) {
        this.submitButton.innerHTML = this.buttonTitle.innerHTML;
      } else {
        this.submitButton.innerHTML = theme.strings.product.addToCart;
      }
    } else {
      this.submitButton.disabled = true;
      this.submitButton.innerHTML = theme.strings.product.soldOut;
    }
  }

  updateOutOfStockOptions() {
    const $option1 = this.querySelector('input[id^=Option1]:checked');
    const $option2 = this.querySelector('input[id^=Option2]:checked');

    const option1 = $option1 ? $option1.value : null;
    const option2 = $option2 ? $option2.value : null;

    /**
     * we check the status of every swatch.
     *
     * For the first option we just check if any variant is available with that value.
     *
     * For the second option we check if any variant is available with that value and the currently selected first option.
     *
     * For the third option we check if any variant is available with that value and the currently selected first and second options.
     */
    this.allSwatches.forEach(optionInput => {
      if (optionInput.dataset.optionPosition == 1) {
        var availableWithValue = this.product.variants.find(
          variantCompare =>
            variantCompare.option1 === optionInput.value &&
            variantCompare.available
        );
      }
      else if (optionInput.dataset.optionPosition == 2) {
        var availableWithValue = this.product.variants.find(
          variantCompare =>
            variantCompare.option1 === option1 &&
            variantCompare.option2 === optionInput.value &&
            variantCompare.available
        );
      }
      else if (optionInput.dataset.optionPosition == 3) {
        var availableWithValue = this.product.variants.find(
          variantCompare =>
            variantCompare.option1 === option1 &&
            variantCompare.option2 === option2 &&
            variantCompare.option3 === optionInput.value &&
            variantCompare.available
        );
      }

      if (availableWithValue) {
        optionInput.classList.remove('swatches__disabled');
      }
      else {
        optionInput.classList.add('swatches__disabled');
      }
    });
  }

  updateSlideImages(variant) {
    if(variant && this.imageSwiper) {
      /**
       * Go to the variant featured image or first image.
       */
      if(variant.featured_media) {
        const imageId = variant.featured_media.id;
        const imageElement = this.imageSwiper.querySelector(`[data-media-id="${imageId}"]`);
        let imageIndex = [...Array.from(this.imageSwiper.querySelectorAll('.swiper-slide'))].indexOf(imageElement);

        if(imageIndex === -1) {
          imageIndex = 0;
        }

        this.imageSwiper.swiper.slideTo(imageIndex, 500);
      }
    }
  }

  extensionEmailCheck() {
    const fullUrl = window.location.href;
    const emailParam = new URL(fullUrl).searchParams.get('e');
    const searchParams = new URLSearchParams(window.location.search);
    const encodedEmail = searchParams.get('e') ? searchParams.get('e') : emailParam;
    let email = encodedEmail; // if the email isn't encoded, don't try to decode it
    if(encodedEmail) {
      if(!encodedEmail.includes("@") && !encodedEmail.includes(".")) {
        email = window.atob(encodedEmail);
      }
    }

    if (encodedEmail !== null && email.includes('@')) {
      const renewEmailInput = this.querySelector('[name="properties[_renewemail]"]');
      renewEmailInput.value = email;
      this.isValidEmail = true;

      this.submitButton.disabled = false;
    }
  }
}

try {
  customElements.define('product-form', ProductFormElement);
}
catch(e) {
  console.log("product-form already defined", e)
}
